import { create } from 'zustand';

export interface UsePastPeriodState {
  selectedPastPeriodId: string | null;
}

export interface UsePastPeriodActions {
  setSelectedPastPeriodId: (periodId: string | null) => void;
}

export const usePastPeriodStore = create<UsePastPeriodState & UsePastPeriodActions>(set => ({
  selectedPastPeriodId: null,
  setSelectedPastPeriodId: (periodId: string | null) => set({ selectedPastPeriodId: periodId }),
}));
